import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { InvestmentPropertyModel } from './investment-property.model';
import { InvestmentPropertyService } from './investment-property.service';

@Component({
    selector: 'convfact-investment-property',
    templateUrl: './investment-property.component.html',
    styleUrls: ['./investment-property.component.css'],
    standalone: false
})

export class InvestmentPropertyComponent implements OnInit {

  public investmentProperty = new InvestmentPropertyModel;
  public accounts: AccountingAccountsModel[] = [];

  public spinner: boolean = false;
  public ready: boolean = false;

  constructor(
    private investmentPropertyService: InvestmentPropertyService,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

  public ngOnInit(): void {
    this.accountingAccountsService.getListInvestmentsPropertyAccounts()
    .then(data => this.accounts = data);

    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 5) {
      const uid = temp[4];
      this.investmentPropertyService.get(uid)
        .then(response => {
          this.investmentProperty = response;
          this.spinner = false;
          this.ready = true;
        })
    }
    else {
      this.spinner = false;
      this.ready = true;
    }
  }

  public saveData(investmentProperty: InvestmentPropertyModel): void {
    this.spinner = true;

    if (investmentProperty.uid == null) {
      this.investmentPropertyService.add(investmentProperty)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(error.error['message']);
        })
    } else {
      this.investmentPropertyService.edit(investmentProperty)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError("Ha ocurrido un error inesperado al actualizar la inversion")
        })
    }
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['investment/property']);
  }
}
